import React, { useContext, useEffect, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import {
  FaArrowLeft,
  FaCrown,
  FaBookOpen,
  FaCloudDownloadAlt,
  FaSyncAlt,
  FaShieldAlt,
  FaCheckCircle,
  FaLock,
  FaGraduationCap,
  FaAward,
  FaRegClock,
  FaUsers,
  FaHeadset,
  FaWhatsapp,
  FaChevronDown,
} from "react-icons/fa";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import AuthContext from "../contexts/auth";
import api from "../services/config.url";
import showPopup from "../components/PopUp";
import Payments from "../components/payments";

const WHATSAPP_LINK = "https://wa.me/5562995584021";

// Capas 3D com fundo transparente (public/) para o leque do hero.
const HERO_BOOKS = [
  `${process.env.PUBLIC_URL}/img1.png`,
  `${process.env.PUBLIC_URL}/img3.png`,
  `${process.env.PUBLIC_URL}/img2.png`,
  `${process.env.PUBLIC_URL}/img4.png`,
  `${process.env.PUBLIC_URL}/img5.png`,
  `${process.env.PUBLIC_URL}/img6.png`,
];

const FEATURES = [
  {
    icon: <FaBookOpen />,
    title: "TODOS os Cadernos",
    text: "Tudo que você precisa em um só lugar",
  },
  {
    icon: <FaCloudDownloadAlt />,
    title: "Downloads Ilimitados",
    text: "Baixe quantas vezes quiser, sem limitações",
  },
  {
    icon: <FaSyncAlt />,
    title: "Atualizações Constantes",
    text: "Novos cadernos e atualizações disponíveis automaticamente",
  },
  {
    icon: <FaShieldAlt />,
    title: "1 Ano de Acesso",
    text: "Acesso garantido por 12 meses a partir da confirmação",
  },
];

const BENEFITS = [
  "Acesso ao catálogo inteiro, das 24 matérias, sem comprar uma a uma.",
  "Cada atualização de lei, súmula e jurisprudência chega sem custo extra.",
  "Todo caderno novo lançado no ano já cai na sua estante.",
  "Baixe à vontade e estude no seu tempo, do seu jeito.",
  "Material pensado para carreira: magistratura, MP, defensoria, procuradorias e OAB.",
  "Menos de R$ 1 por dia para ter na mão o que, avulso, custaria o catálogo inteiro.",
];

const QUALITIES = [
  {
    icon: <FaGraduationCap />,
    title: "Aprovados na Prática",
    text: "Cadernos escritos por quem estudou por eles e foi aprovado em concurso",
  },
  {
    icon: <FaAward />,
    title: "Materiais Completos",
    text: "Lei comentada, teoria, questões e jurisprudência num só lugar",
  },
  {
    icon: <FaRegClock />,
    title: "Sempre Atualizados",
    text: "Revisão e atualização contínuas ao longo do ano",
  },
  {
    icon: <FaUsers />,
    title: "Milhares de Estudantes",
    text: "Você estuda junto de quem já confia nos Cadernos",
  },
];

const FAQ = [
  {
    q: "Como funciona a assinatura?",
    a: "Ao assinar o Plano Anual, você libera o acesso a todos os cadernos jurídicos do site por 12 meses. Basta escolher a forma de pagamento e, após a confirmação, o acesso é liberado automaticamente.",
  },
  {
    q: "O acesso é realmente ilimitado?",
    a: "Sim. Durante a vigência da assinatura você pode visualizar e baixar quantos cadernos quiser, sem limite de downloads e sem precisar comprar cada matéria separadamente.",
  },
  {
    q: "Por quanto tempo terei acesso?",
    a: "O acesso é válido por 12 meses contados a partir da confirmação do pagamento. Você pode renovar a qualquer momento para não perder os benefícios.",
  },
  {
    q: "Posso cancelar a qualquer momento?",
    a: "A assinatura é anual e não gera cobranças automáticas. Ao final dos 12 meses o acesso simplesmente expira, e você decide se quer renovar — sem burocracia.",
  },
  {
    q: "Como recebo os materiais?",
    a: "Nada de esperar e-mail: assim que o pagamento é confirmado, todos os cadernos ficam acessíveis direto na sua área \"Meus Cadernos\", prontos pra ler e baixar.",
  },
];

const modalBoxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90vw",
  maxWidth: "600px",
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  borderRadius: "12px",
  boxShadow: 24,
  p: 4,
};

function AssineAgora() {
  const { user, isAuthenticated, setLoading } = useContext(AuthContext);
  const navigate = useHistory();
  const [subscriptionOrder, setSubscriptionOrder] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [openFaq, setOpenFaq] = useState(0);
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);

  const isPremium = !!(
    user?.subscriptionExpiresAt &&
    new Date(user.subscriptionExpiresAt) > new Date()
  );

  useEffect(() => {
    if (!isAuthenticated || isPremium) return;

    api
      .post("/customers/subscription/checkout")
      .then((response) => setSubscriptionOrder(response.data))
      .catch((error) => {
        const backendError = error?.response?.data?.message;
        setErrorMessage(backendError || "Não foi possível iniciar a assinatura.");
      });
  }, [isAuthenticated, isPremium]);

  const handleAssine = () => {
    if (!isAuthenticated) {
      showPopup("Faça login para assinar o Plano Anual.", "alert");
      navigate.push("/acesso");
      return;
    }
    if (isPremium) {
      showPopup("Você já é Assinante Anual!", "success");
      navigate.push("/perfil");
      return;
    }
    if (errorMessage) {
      showPopup(errorMessage, "error");
      navigate.push("/perfil");
      return;
    }
    if (!subscriptionOrder) {
      showPopup("Estamos preparando sua assinatura, tente novamente em instantes.", "alert");
      return;
    }
    setIsPaymentOpen(true);
  };

  const AssineButton = ({ className = "" }) => (
    <button
      type="button"
      className={`aa-btn-gold ${className}`}
      onClick={handleAssine}
    >
      <FaCrown className="aa-btn-crown" />
      Assine o Plano Anual
    </button>
  );

  return (
    <div className="assine-agora-page">
      {/* HERO */}
      <section className="aa-hero">
        <div className="container">
          <Link to="/" className="aa-back">
            <FaArrowLeft /> Voltar para a página principal
          </Link>
          <div className="aa-hero-inner">
            <div className="aa-hero-text">
              <span className="aa-kicker aa-kicker-gold">ASSINATURA - PLANO ANUAL</span>
              <h1 className="aa-hero-title">
                Tenha acesso ilimitado a todos os Cadernos por 1 ano!
              </h1>
              <p className="aa-hero-sub">
                Tenha acesso ilimitado a materiais jurídicos de excelência,
                durante o ano inteiro, por menos de R$ 1 por dia.
              </p>
              <AssineButton className="aa-btn-lg" />
              <p className="aa-hero-secure">
                <FaShieldAlt /> Pagamento seguro e acesso imediato
              </p>
            </div>
            <div className="aa-hero-books">
              {HERO_BOOKS.map((src, i) => (
                <div key={i} className={`aa-hero-book aa-hero-book-${i}`}>
                  <img src={src} alt="" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FEATURE BAR */}
      <div className="container">
        <div className="aa-features">
          {FEATURES.map((f, i) => (
            <div className="aa-feature" key={i}>
              <div className="aa-feature-icon">{f.icon}</div>
              <h4 className="aa-feature-title">{f.title}</h4>
              <p className="aa-feature-text">{f.text}</p>
            </div>
          ))}
        </div>
      </div>

      {/* POR QUE ASSINAR */}
      <section className="aa-section aa-why">
        <div className="container">
          <div className="aa-why-inner">
            <div className="aa-why-text">
              <span className="aa-kicker aa-kicker-gold">Por que assinar?</span>
              <h2 className="aa-section-title">
                Vantagens que fazem toda a diferença nos seus estudos.
              </h2>
              <ul className="aa-benefits">
                {BENEFITS.map((b, i) => (
                  <li key={i}>
                    <FaCheckCircle className="aa-benefit-check" />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="aa-price-card">
              <span className="aa-price-badge">Melhor custo-benefício</span>
              <h3 className="aa-price-title">Assinatura - Plano Anual</h3>
              <div className="aa-price-value">
                <span className="aa-price-currency">R$</span>
                <span className="aa-price-number">360,00</span>
                <span className="aa-price-period">/ por ano</span>
              </div>
              <p className="aa-price-per-day">por menos de R$ 1 por dia</p>
              <p className="aa-price-installment">ou em até 12x de R$ 30,00*</p>
              <div className="aa-price-highlight">
                <FaCrown className="aa-price-highlight-icon" />
                <span style={{ textAlign: "justify" }}>
                  Tenha acesso ilimitado, durante 12 meses, a todos os
                  Cadernos do site, bem como às respectivas revisões,
                  atualizações e lançamentos.
                </span>
              </div>
              <AssineButton className="aa-btn-block" />
              <p className="aa-price-secure">
                <FaLock /> Ambiente seguro. Seus dados protegidos.
              </p>
              <p className="aa-price-note">
                *Parcelamento realizado via plataforma de pagamento.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* QUALIDADE */}
      <section className="aa-section aa-quality">
        <div className="container">
          <h2 className="aa-quality-title">
            Conteúdo de qualidade, feito por especialistas
          </h2>
          <div className="aa-quality-grid">
            {QUALITIES.map((q, i) => (
              <div className="aa-quality-item" key={i}>
                <div className="aa-quality-icon">{q.icon}</div>
                <h4 className="aa-quality-name">{q.title}</h4>
                <p className="aa-quality-text">{q.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="aa-section aa-faq">
        <div className="container">
          <span className="aa-kicker aa-kicker-gold">Dúvidas frequentes</span>
          <h2 className="aa-section-title aa-faq-title">Perguntas frequentes</h2>
          <div className="aa-faq-inner">
            <div className="aa-faq-list">
              {FAQ.map((item, i) => (
                <div
                  className={`aa-faq-item ${openFaq === i ? "is-open" : ""}`}
                  key={i}
                >
                  <button
                    type="button"
                    className="aa-faq-question"
                    onClick={() => setOpenFaq(openFaq === i ? -1 : i)}
                  >
                    <span>{item.q}</span>
                    <FaChevronDown className="aa-faq-chevron" />
                  </button>
                  {openFaq === i && (
                    <div className="aa-faq-answer">{item.a}</div>
                  )}
                </div>
              ))}
            </div>
            <div className="aa-faq-help">
              <FaHeadset className="aa-faq-help-icon" />
              <h4 className="aa-faq-help-title">Ainda tem dúvidas?</h4>
              <p className="aa-faq-help-text">
                Nossa equipe está pronta para te atender!
              </p>
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="aa-faq-help-btn"
              >
                <FaWhatsapp /> Falar conosco
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="aa-cta">
        <div className="container">
          <FaCrown className="aa-cta-crown" />
          <h2 className="aa-cta-title">Invista no seu futuro. Assine agora!</h2>
          <p className="aa-cta-sub">
            Tenha acesso ilimitado aos melhores materiais jurídicos e estude com
            quem realmente entende do assunto.
          </p>
          <AssineButton className="aa-btn-lg" />
          <p className="aa-cta-note">
            Acesso imediato após a confirmação do pagamento
          </p>
        </div>
      </section>

      {/* PAYMENT MODAL */}
      <Modal
        open={isPaymentOpen}
        onClose={() => setIsPaymentOpen(false)}
        sx={{ zIndex: 99999 }}
      >
        <Box sx={modalBoxStyle}>
          <h4 className="widget-title">Finalizar assinatura</h4>
          <div className="layout-payments">
            {subscriptionOrder && (
              <Payments
                currentOrder={subscriptionOrder}
                canFinish={true}
                readyToPayment={() => {
                  setIsPaymentOpen(false);
                  showPopup(
                    "Pagamento em processamento! Assim que aprovado, sua assinatura será liberada.",
                    "success"
                  );
                }}
              />
            )}
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default AssineAgora;
